<ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
  <!-- <div class="ion-text-center">
    <img src="assets/img/dots1.svg" />
  </div> -->
  <ion-refresher-content></ion-refresher-content>
</ion-refresher>